module.exports = __webpack_public_path__ + "static/img/back_small.45a9931.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/back_small.svg
// module id = KRQX
// module chunks = 1